export default __webpack_public_path__ + "static/media/hamburger.85706c47.svg";